<script lang="ts" setup></script>

<template>
  <div>
    <img src="/logo.png" alt="logo" class="h-8 w-8" />
  </div>
</template>

<style lang="scss" scoped></style>
